var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReporting = function SvgReporting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M17 2h3.6L14 8.6l-4-4-9.7 9.7 1.4 1.4L10 7.4l4 4 8-8V7h2V0h-7zM22 11h-6v11h-1v-8H9v8H8v-4H2v4H0v2h24v-2h-2zm-4 2h2v9h-2zm-7 3h2v6h-2zm-7 4h2v2H4z"
  })));
};
export default SvgReporting;